<template>
  <section>
    <h1>Agregar Expediente</h1>
    <hr/><br/>

    <form @submit.prevent="submit">
      <div class="mb-3">
          <label for="number" class="form-label">Expediente:</label>
          <input type="text" name="number" v-model="form.number" class="form-control" />
          <div v-if="errors.number" class="error">{{ errors.number }}</div>
        </div>
        <div class="mb-3">
          <label for="description" class="form-label">Descripción:</label>
          <textarea
            name="description"
            v-model="form.description"
            class="form-control"
          ></textarea>
          <div v-if="errors.description" class="error">{{ errors.description }}</div>
        </div>
        <button type="submit" class="btn btn-primary">Guardar</button>
        <button type="button" class="btn btn-secondary" @click="cancel">Cancelar</button>

        </form>
  </section>
</template>

<script>
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default defineComponent({
  name: 'AddProceeding',
  data() {
    return {
      form: {
        number: '',
        description: '',
      },
      errors: {
        number: '',
        description: '',
      },
    };
  },
  computed: {
    ...mapGetters({ user: 'stateUser' }),
  },
  methods: {
    ...mapActions(['createProceeding']),
    validateForm() {
      let isValid = true;
      this.errors.number = '';
      this.errors.description = '';

      if (!this.form.number) {
        this.errors.number = 'No Expediente es requerido';
        isValid = false;
      }
      if (!this.form.description) {
        this.errors.description = 'Descripción es requerida';
        isValid = false;
      }

      return isValid;
    },
    async submit() {
      if (!this.validateForm()) {
        return;
      }
     try {
        const proceeding = {
          number: this.form.number,
          description: this.form.description,
          user_id: this.user.id,
        };
        console.log('vista',proceeding);
        await this.createProceeding(proceeding);
        this.$router.push('/dashboard');
    } catch (error) {
      console.log(error);
    }
    },
    cancel() {
      this.$router.push('/dashboard');
    },
  },
});
</script>

<style scoped>
.error {
  color: red;
}
</style>